import actionTypes from 'SRC/modules/redux/actionTypes'

export const setBrands = (brands) => ({
  type: actionTypes.SET_BRANDS,
  payload: brands
})
